// extracted by mini-css-extract-plugin
export default {"strip":"ScopeStrip_strip__NdQs+","icon":"ScopeStrip_icon__6athS"};